import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.overlay = document.querySelector('.js-nav-overlay');
        this.panels = document.querySelector('.js-nav-overlay-panels');
        this.panel = this.el.dataset.panel;
        this.panelEl = document.querySelector('#' + this.panel);

        // when you hover this.el add class is-active to this.overlay and also on this.panelEl, remove it when you leave
        this.el.addEventListener('mouseenter', () => {
            this.overlay.classList.add('is-active');
            this.panelEl.classList.add('is-active');
        });

        this.el.addEventListener('mouseleave', () => {
            this.overlay.classList.remove('is-active');
            this.panelEl.classList.remove('is-active');
        });

        this.panelEl.addEventListener('mouseenter', () => {
            if (window.innerWidth >= 1080) {
                this.overlay.classList.add('is-active');
                this.panelEl.classList.add('is-active');
            }
        });

        this.panelEl.addEventListener('mouseleave', () => {
            if (window.innerWidth >= 1080) {
                this.overlay.classList.remove('is-active');
                this.panelEl.classList.remove('is-active');
            }
        });
    }
}
